import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinusCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3252 14.4001 9.69736 14.4001 7.99998C14.4001 6.30259 13.7258 4.67473 12.5256 3.47449C11.3253 2.27426 9.69748 1.59998 8.0001 1.59998C6.30271 1.59998 4.67485 2.27426 3.47461 3.47449C2.27438 4.67473 1.6001 6.30259 1.6001 7.99998C1.6001 9.69736 2.27438 11.3252 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM5.4001 7.39998C5.24097 7.39998 5.08836 7.46319 4.97583 7.57571C4.86331 7.68823 4.8001 7.84085 4.8001 7.99998C4.8001 8.15911 4.86331 8.31172 4.97583 8.42424C5.08836 8.53676 5.24097 8.59998 5.4001 8.59998H10.6001C10.7592 8.59998 10.9118 8.53676 11.0244 8.42424C11.1369 8.31172 11.2001 8.15911 11.2001 7.99998C11.2001 7.84085 11.1369 7.68823 11.0244 7.57571C10.9118 7.46319 10.7592 7.39998 10.6001 7.39998H5.4001Z",
		fill: "currentcolor"
	})]
});
export default SvgMinusCircleFillMini;
